<template>
    <veui-dialog
        :open.sync="modalOpen"
        :closable="false"
        :footless="true"
    >
        <div
            v-visually="{
                serverId: 20661,
                area: trackPrefix + '-show',
                isNotRepeat: true,
                ext: {action: 'show'},
            }"
            class="golden-booth-dialog"
        >
            <div class="dialog-header">
                <div class="header-title">SVIP卓越会员专属C位律师特权待开启</div>
                <veui-icon
                    name="times"
                    class="close-icon"
                    @click.native="handleClose"
                />
            </div>
            <img
                class="dialog-banner"
                src="https://lvlin-fe-saas.cdn.bcebos.com/home/goldenboothdialog/pc-lawyer-banner.png"
            >
            <div class="dialog-tip">
                <span class="text-blod">C位律师强曝光：</span>开通可享多端、多场景7日首位固定展示权益，精准投放至您所在地域、专长领域，提升曝光与获客效率
            </div>
            <div class="privilege-grid">
                <div
                    v-for="item in privilegeList"
                    :key="item.title"
                    class="privilege-item"
                >
                    <img class="item-icon" :src="item.icon">
                    <div class="item-title">{{ item.title }}</div>
                    <div class="item-desc">{{ item.desc }}</div>
                </div>
            </div>
            <div class="dialog-footer">
                <div
                    :class="['action-btn', {'is-disabled': isSubmitting}]"
                    @click="handleSubmit"
                >点击获取客服专属对接介绍</div>
            </div>
        </div>
    </veui-dialog>
</template>
<script>
import {Icon, Dialog} from 'veui';

export default {
    name: 'GoldenBoothDialog',
    components: {
        VeuiIcon: Icon,
        VeuiDialog: Dialog
    },
    props: {
        show: {
            type: Boolean,
            default: false
        },
        source: {
            type: String,
            default: 'home'
        },
        popupKey: {
            type: String,
            default: ''
        },
        entrySource: {
            type: String,
            default: 'home'
        }
    },
    data() {
        return {
            modalOpen: false,
            isSubmitting: false,
            privilegeList: [
                {
                    title: '搜索/地图首位强曝光',
                    desc: '覆盖百度搜索、地图等场域律师首位强曝光展示',
                    icon: 'https://lvlin-fe-saas.bj.bcebos.com/home/goldenboothdialog/cpt-search-exposure.png'
                },
                {
                    title: '律师列表置顶',
                    desc: '推荐列表首位展示，让客户优先看到您',
                    icon: 'https://lvlin-fe-saas.cdn.bcebos.com/home/goldenboothdialog/cpt-list-top.png'
                },
                {
                    title: '移动端首位曝光',
                    desc: '严选律师首位推荐，叠加首页营销推广位曝光',
                    icon: 'https://lvlin-fe-saas.cdn.bcebos.com/home/goldenboothdialog/cpt-mobile-first.png'
                },
                {
                    title: 'PC首页大屏推荐',
                    desc: '首页大屏优先推荐，先抢占用户第一焦点',
                    icon: 'https://lvlin-fe-saas.cdn.bcebos.com/home/goldenboothdialog/cpt-pc-home.png'
                }
            ]
        };
    },
    watch: {
        show: {
            immediate: true,
            handler(val) {
                this.modalOpen = val;
            }
        },
        modalOpen(val) {
            if (!val) {
                this.$emit('cancel');
            }
        }
    },
    computed: {
        trackPrefix() {
            return (this.source || 'home') + '-cpt-clawyer';
        }
    },
    methods: {
        handleClose() {
            this.modalOpen = false;
            this.recordPopup();
        },
        // 上报关闭记录
        recordPopup() {
            if (!this.popupKey) {
                return;
            }
            this.$http.post('/bp/popup-api/record', {
                popup_key: this.popupKey
            }).catch(() => {});
        },
        // 提交咨询意愿
        handleSubmit() {
            if (this.isSubmitting) {
                return;
            }
            this.$wywLog.send({
                serverId: 20661,
                area: this.trackPrefix + '-cpt-clawyer-click',
                action: 'click'
            });
            this.isSubmitting = true;
            this.$http
                .post('/bp/api/vip/cpt/intention', {entry_source: this.entrySource})
                .then(res => {
                    if (+res?.code === 0) {
                        this.$toast.success('已提交，客服会尽快与您联系');
                        this.modalOpen = false;
                    }
                    else {
                        this.$toast.error('提交失败，请稍后再试~');
                    }
                })
                .catch(() => {
                    this.$toast.error('提交失败，请稍后再试~');
                })
                .finally(() => {
                    this.isSubmitting = false;
                });
        }
    }
};
</script>
<style lang="less" scoped>
/deep/ .veui-dialog-content {
    width: 844px !important;
    min-width: 844px !important;
    max-width: 844px !important;
    padding: 0;
    border-radius: 8px;
    overflow: hidden;

    .veui-dialog-content-head {
        display: none;
    }

    .veui-dialog-content-body {
        padding: 0;
    }
}

.golden-booth-dialog {
    position: relative;
    padding: 21px 24px 18px;
    background-color: #fff;
    border-radius: 8px;
    overflow: hidden;

    .dialog-header {
        display: flex;
        align-items: center;
        margin-bottom: 21px;

        .header-title {
            flex: 1;
            font-family: "PingFang SC";
            font-size: 18px;
            font-weight: 500;
            line-height: 18px;
            color: #000311;
        }

        .close-icon {
            width: 24px;
            height: 24px;
            font-size: 24px;
            line-height: 24px;
            color: #1e1f24;
            cursor: pointer;
        }
    }

    .dialog-banner {
        display: block;
        width: 100%;
        height: 240px;
        object-fit: contain;
        border-radius: 6px;
    }

    .dialog-tip {
        margin-top: 12px;
        padding: 10px 12px;
        border-radius: 6px;
        background: #fef4e0;
        font-family: "PingFang SC";
        font-size: 14px;
        line-height: 14px;
        color: #8c3a00;

        .text-blod {
            font-weight: 500;
        }
    }

    .privilege-grid {
        display: grid;
        grid-template-columns: repeat(4, minmax(0, 1fr));
        gap: 8px;
        margin-top: 12px;

        .privilege-item {
            padding: 20px 15px;
            border-radius: 6px;
            background: #fafcff;
            border: .5px solid rgba(0, 0, 0, .06);
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;

            .item-icon {
                display: block;
                width: 36px;
                height: 36px;
            }

            .item-title {
                margin-top: 14px;
                font-family: "PingFang SC";
                font-size: 15px;
                font-weight: 500;
                line-height: 15px;
                color: #1e1f24;
            }

            .item-desc {
                margin-top: 8px;
                font-family: "PingFang SC";
                font-size: 13px;
                line-height: 21px;
                color: #848691;
                text-align: center;
            }
        }
    }

    .dialog-footer {
        display: flex;
        justify-content: center;
        margin-top: 18px;

        .action-btn {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 304px;
            height: 44px;
            border-radius: 6px;
            background: linear-gradient(89.83deg, #ffeabf .15%, #ffdaa6 99.85%);
            font-family: "PingFang SC";
            font-size: 16px;
            font-weight: 500;
            line-height: 16px;
            color: #401506;
            cursor: pointer;

            &.is-disabled {
                opacity: .6;
                cursor: not-allowed;
            }
        }
    }
}
</style>

